// Global variable from webpack
import { datadogLogs } from '@datadog/browser-logs';
import { environment } from '@environments/environment';
import browserHelper from '@utils/browser-helper';
import { env } from '@app/shared/services/env';
import version from '../../../version.json';

const isMfe = !!(window as any).singleSpaNavigate;

export const initLogs = (appName: string) => {
  if (environment.DEBUG || isMfe) {
    // Don't run in dev environment
    return;
  }

  datadogLogs.init({
    clientToken: 'pub9147360f5c434bc2db3c3836eda0fab8',
    env: env(),
    site: 'datadoghq.eu',
    service: browserHelper.isInWrapper ? 'fb2go' : 'web',
    forwardErrorsToLogs: true,
    sampleRate: 100,
    version: `${version.majorVersion}.${version.minorVersion}.${version.patchVersion}`,
    beforeSend: log => {
      // remove events which can leak token
      if (log.message?.indexOf('Bearer ') !== -1) {
        return false;
      }
      // bearer token included into the url
      if (log.message?.indexOf('eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9') !== -1) {
        return false;
      }
      // status_code=0 shows that it was a client error when user navigated away from the page
      if (log.http?.status_code === 0) {
        return false;
      }
    }
  });

  if (appName) {
    datadogLogs.addLoggerGlobalContext('app', appName);
  }
};

const log = (level: string, message: string, context: object) => {
  if (environment.DEBUG || isMfe) {
    return;
  }

  datadogLogs.logger[level](message, context);
};

export const debug = (message: string, context: object) => log('debug', message, context);
export const error = (message: string, context: object) => log('error', message, context);
export const info = (message: string, context: object) => log('info', message, context);
export const warn = (message: string, context: object) => log('warn', message, context);
